var $ab35ca149e74c27f$exports = {};
$ab35ca149e74c27f$exports = {
    "Clear search": `Limpar pesquisa`
};


export {$ab35ca149e74c27f$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
